import { render, staticRenderFns } from "./SearchResultsItem.vue?vue&type=template&id=5ad3538a&scoped=true&"
import script from "./SearchResultsItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultsItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsItem.vue?vue&type=style&index=0&id=5ad3538a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad3538a",
  null
  
)

export default component.exports